import { Table, TableHead, TableRow, TableCell } from '@mui/material';
import { DndContext, closestCenter, DragEndEvent } from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { useTranslation } from 'react-i18next';
import { MenuItemList } from './MenuItemList';
import { SelectOption } from '../../../../../app/components/SelectOption';
import MealItem from '../../../../../app/data/models/mealItem';

interface Props {
  selectedMealItems: MealItem[];
  mealItemSelectionList: SelectOption[];
  target: string;
  onDragEnd: (event: DragEndEvent) => void;
  onRemoveMealItem: (id: string) => void;
  onAddItem: (id: string) => void;
}

export const MenuItemTable: React.FC<Props> = ({
  selectedMealItems,
  mealItemSelectionList,
  target,
  onDragEnd,
  onRemoveMealItem,
  onAddItem,
}) => {
  const { t } = useTranslation();

  return (
    <DndContext collisionDetection={closestCenter} onDragEnd={onDragEnd}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width="50px"></TableCell>
            <TableCell>{t('menu.details.header.name')}</TableCell>
            <TableCell align="right">
              {t('menu.details.header.price')}
            </TableCell>
            <TableCell align="right" width="120px"></TableCell>
          </TableRow>
        </TableHead>
        <SortableContext
          items={selectedMealItems.map((item) => item.id)}
          strategy={verticalListSortingStrategy}
        >
          <MenuItemList
            selectedMealItems={selectedMealItems}
            mealItemSelectionList={mealItemSelectionList}
            target={target}
            onRemoveMealItem={onRemoveMealItem}
            onAddItem={onAddItem}
          />
        </SortableContext>
      </Table>
    </DndContext>
  );
};
